<template>
  <div>
    <v-btn
      v-if="swwConfigActive"
      prepend-icon="mdi-weather-sunny"
      color="warning"
      @click="activateModal()"
    >
      SWW Config
    </v-btn>
    <v-dialog
      v-model="buttonConfigModalActive"
      :can-cancel="false"
      has-modal-card
      max-width="700"
    >
      <SwwConfigEditor
        v-model:config="model"
        @close="buttonConfigModalActive = false"
      />
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'
import { computed, onMounted, ref } from 'vue'

import { createDefaultSww } from '@/apps/brelag/common/models/brelagSwwDefault'
import { SwwConfig } from '@/apps/brelag/common/models/swwParams'
import SwwConfigEditor from '@/apps/brelag/mandator-user/components/editor/sww/SwwConfigEditor.vue'
import { SchemaFormKitProps } from '@/components/common/forms/editor-fields/formkit/types'

const model = defineModel<SwwConfig>()
const props = defineProps<SchemaFormKitProps>()
const buttonConfigModalActive = ref(false)
const context = useFormKitContext()

onMounted(maybeApplyDefault)

function maybeApplyDefault() {
  if (!model.value) model.value = createDefaultSww() // Load default config
}

function activateModal() {
  maybeApplyDefault()
  buttonConfigModalActive.value = true
}

const swwConfigActive = computed(() => {
  if (!props.field.properties.extraData?.dependencyKey) return true
  const depKey = props.field.properties.extraData.dependencyKey
  if (context.value.value.value[depKey]) {
    return context.value.value.value[depKey]
  }

  return false
})
</script>

<style></style>
